import { render, staticRenderFns } from "./BulkDelivery.vue?vue&type=template&id=19499928&"
import script from "./BulkDelivery.vue?vue&type=script&lang=js&"
export * from "./BulkDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports